import angular from 'angular';

module.exports = angular.module('common.directives.convert-to-number', [])
.directive('convertToNumber', function() {
  return {
	restrict: 'A',
    require: 'ngModel',
    link: function(scope, element, attrs, ngModel) {
      ngModel.$parsers.push(function(val) {
        return parseInt(val, 10);
      });
      ngModel.$formatters.push(function(val) {
        return '' + val;
      });
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/convert-to-number.js
 **/